"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var jsx_runtime_1 = require("react/jsx-runtime");
var hook_use_bem_classes_1 = __importDefault(require("@rotaryintl/hook-use-bem-classes"));
require("./styles.css");
var InfogramEmbed = function (props) {
    var bem = (0, hook_use_bem_classes_1.default)('rwc-infogram-embed');
    var embedUrl = "https://infogram.com/".concat(props.infogramID);
    return ((0, jsx_runtime_1.jsx)("div", __assign({ className: bem() }, { children: (0, jsx_runtime_1.jsx)("iframe", { className: bem('iframe'), allow: "autoplay", title: props.title, src: embedUrl, height: "1000px", width: "1000px" }) })));
};
exports.default = InfogramEmbed;
//# sourceMappingURL=infogram-embed.component.js.map